import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './assets/jquery.min'
import './assets/bootstrap.bundle';
import './assets/sb-admin-2.min.css';
import './assets/datatables/jquery.dataTables.min.js';
import './assets/datatables/dataTables.bootstrap4.min.css';
import fontawesome from '@fortawesome/fontawesome-free/css/all.css'
import './assets/custom.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
// import VueAuth from '@websanova/vue-auth'
// import BootBox from 'bootbox'
import BootstrapVue from 'bootstrap-vue'

import VueHighlightJS from 'vue-highlightjs'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/heighlight.min.css'
import VueStripeCheckout from 'vue-stripe-checkout';
Vue.config.productionTip = false;
import moment from "moment";
// window.bootbox = BootBox;
import _ from 'lodash';
import {get} from 'lodash';
import store from './store/store' 
import filters from './utils/filter'

Vue.use(VueHighlightJS);
Vue.use(fontawesome);
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios);
Vue.router = router;

let configs = {
  dev: {
    apiUrl: "http://localhost:3001",
    stripePk: 'pk_test_Ef9dw9xZC5uCu5moex8Rn7RP00r57sz1ig',
  },
  uat:{
    // apiUrl: "http://localhost:3000",
    apiUrl: "https://api-uat.supermeteor.com/",
    stripePk: 'pk_test_Ef9dw9xZC5uCu5moex8Rn7RP00r57sz1ig',
  },
  prod: {
    apiUrl: 'https://api.supermeteor.com/',
    stripePk: 'pk_live_SwZhzWQyZeowwrOdWLIAPers00UHzvN5El',
  }
}
configs.development = configs.dev
configs.production = configs.prod
configs.test = configs.uat

let env = process.env.VUE_APP_ENV
// if (env){
//   env = env
// }
// else if (
//     location.host.startsWith("dash-uat")
//     || location.host.startsWith("code-preview")
// ){
//   env = 'uat'
// }
// else if (
//   location.host.startsWith("localhost")
//   || location.host.startsWith("127.0")
//   || location.host.startsWith("192.")
// ){
//   env = 'uat'
// }
// else if (
//   location.host.startsWith("dash.")
// ){
//   env = 'prod'
// }

let config = configs[env]
console.log({
  env,
  config,
  envs: process.env
})
Vue.use(VueStripeCheckout, config.stripePk);

Vue.axios.defaults.baseURL = config.apiUrl
Vue.prototype.env = process.env.VUE_APP_ENV
Vue.prototype.foo = 'bar'
Vue.prototype.$get = get
Vue.prototype._translationCache = {} // TODO minor cache in memory instead of hit localStory everytime

import interceptorsSetup from './services/interceptors'
// and running it somewhere here
interceptorsSetup();

Vue.mixin({
    methods: {
        jsonString(r){
            try{
                return JSON.stringify(r, null, 2)
            }
            catch(err){
                return '(invalid json)'
            }
        },
    
        txt: function (translationKey) {

            let translate = JSON.parse(localStorage.getItem('translation')) || {}
            let lang = localStorage.getItem('activeLang') || 'en_US';

            let r = translate.translations
            if (!r){
                return `[${translationKey}]`
            }

            r = r[translationKey]
            if (!r){
                return `[${translationKey}]`
            }
            
            r = r[lang]
            if (!r){
                return `[${translationKey}]`
            }

            return r
        },
        languages: function () {
            let language = JSON.parse(localStorage.getItem('translationLanguage')) || []
            return language;
        },
        convertDate: function (str) {
            var d = new Date(str),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");
        }
    },
})

new Vue({
    router,
    store,
    filters,
    created: function () {
        // `this` points to the vm instance
        console.log('created')
    },
    render: h => {
        return h(App);
    }
}).$mount('#app');
